import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, Injectable, ChangeDetectorRef, ElementRef, Directive, HostBinding, NgModule } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';

const flexInputs = [
    'fxFlex',
    'fxFlex.xs',
    'fxFlex.sm',
    'fxFlex.md',
    'fxFlex.lg',
    'fxFlex.xl',
    'fxFlex.lt-sm',
    'fxFlex.lt-md',
    'fxFlex.lt-lg',
    'fxFlex.lt-xl',
    'fxFlex.gt-xs',
    'fxFlex.gt-sm',
    'fxFlex.gt-md',
    'fxFlex.gt-lg',
    'stlrFlex',
    'stlrFlex.xs',
    'stlrFlex.sm',
    'stlrFlex.md',
    'stlrFlex.lg',
    'stlrFlex.xl',
    'stlrFlex.lt-sm',
    'stlrFlex.lt-md',
    'stlrFlex.lt-lg',
    'stlrFlex.lt-xl',
    'stlrFlex.gt-xs',
    'stlrFlex.gt-sm',
    'stlrFlex.gt-md',
    'stlrFlex.gt-lg',
];
const flexAlignInputs = [
    'fxFlexAlign',
    'fxFlexAlign.xs',
    'fxFlexAlign.sm',
    'fxFlexAlign.md',
    'fxFlexAlign.lg',
    'fxFlexAlign.xl',
    'fxFlexAlign.lt-sm',
    'fxFlexAlign.lt-md',
    'fxFlexAlign.lt-lg',
    'fxFlexAlign.lt-xl',
    'fxFlexAlign.gt-xs',
    'fxFlexAlign.gt-sm',
    'fxFlexAlign.gt-md',
    'fxFlexAlign.gt-lg',
    'stlrFlexAlign',
    'stlrFlexAlign.xs',
    'stlrFlexAlign.sm',
    'stlrFlexAlign.md',
    'stlrFlexAlign.lg',
    'stlrFlexAlign.xl',
    'stlrFlexAlign.lt-sm',
    'stlrFlexAlign.lt-md',
    'stlrFlexAlign.lt-lg',
    'stlrFlexAlign.lt-xl',
    'stlrFlexAlign.gt-xs',
    'stlrFlexAlign.gt-sm',
    'stlrFlexAlign.gt-md',
    'stlrFlexAlign.gt-lg',
];
const flexOrderInputs = [
    'fxFlexOrder',
    'fxFlexOrder.xs',
    'fxFlexOrder.sm',
    'fxFlexOrder.md',
    'fxFlexOrder.lg',
    'fxFlexOrder.xl',
    'fxFlexOrder.lt-sm',
    'fxFlexOrder.lt-md',
    'fxFlexOrder.lt-lg',
    'fxFlexOrder.lt-xl',
    'fxFlexOrder.gt-xs',
    'fxFlexOrder.gt-sm',
    'fxFlexOrder.gt-md',
    'fxFlexOrder.gt-lg',
    'stlrFlexOrder',
    'stlrFlexOrder.xs',
    'stlrFlexOrder.sm',
    'stlrFlexOrder.md',
    'stlrFlexOrder.lg',
    'stlrFlexOrder.xl',
    'stlrFlexOrder.lt-sm',
    'stlrFlexOrder.lt-md',
    'stlrFlexOrder.lt-lg',
    'stlrFlexOrder.lt-xl',
    'stlrFlexOrder.gt-xs',
    'stlrFlexOrder.gt-sm',
    'stlrFlexOrder.gt-md',
    'stlrFlexOrder.gt-lg',
];
const layoutInputs = [
    'fxLayout',
    'fxLayout.xs',
    'fxLayout.sm',
    'fxLayout.md',
    'fxLayout.lg',
    'fxLayout.xl',
    'fxLayout.lt-sm',
    'fxLayout.lt-md',
    'fxLayout.lt-lg',
    'fxLayout.lt-xl',
    'fxLayout.gt-xs',
    'fxLayout.gt-sm',
    'fxLayout.gt-md',
    'fxLayout.gt-lg',
    'stlrLayout',
    'stlrLayout.xs',
    'stlrLayout.sm',
    'stlrLayout.md',
    'stlrLayout.lg',
    'stlrLayout.xl',
    'stlrLayout.lt-sm',
    'stlrLayout.lt-md',
    'stlrLayout.lt-lg',
    'stlrLayout.lt-xl',
    'stlrLayout.gt-xs',
    'stlrLayout.gt-sm',
    'stlrLayout.gt-md',
    'stlrLayout.gt-lg',
];
const layoutAlignInputs = [
    'fxLayoutAlign',
    'fxLayoutAlign.xs',
    'fxLayoutAlign.sm',
    'fxLayoutAlign.md',
    'fxLayoutAlign.lg',
    'fxLayoutAlign.xl',
    'fxLayoutAlign.lt-sm',
    'fxLayoutAlign.lt-md',
    'fxLayoutAlign.lt-lg',
    'fxLayoutAlign.lt-xl',
    'fxLayoutAlign.gt-xs',
    'fxLayoutAlign.gt-sm',
    'fxLayoutAlign.gt-md',
    'fxLayoutAlign.gt-lg',
    'stlrLayoutAlign',
    'stlrLayoutAlign.xs',
    'stlrLayoutAlign.sm',
    'stlrLayoutAlign.md',
    'stlrLayoutAlign.lg',
    'stlrLayoutAlign.xl',
    'stlrLayoutAlign.lt-sm',
    'stlrLayoutAlign.lt-md',
    'stlrLayoutAlign.lt-lg',
    'stlrLayoutAlign.lt-xl',
    'stlrLayoutAlign.gt-xs',
    'stlrLayoutAlign.gt-sm',
    'stlrLayoutAlign.gt-md',
    'stlrLayoutAlign.gt-lg',
];
const layoutGapInputs = [
    'fxLayoutGap',
    'fxLayoutGap.xs',
    'fxLayoutGap.sm',
    'fxLayoutGap.md',
    'fxLayoutGap.lg',
    'fxLayoutGap.xl',
    'fxLayoutGap.lt-sm',
    'fxLayoutGap.lt-md',
    'fxLayoutGap.lt-lg',
    'fxLayoutGap.lt-xl',
    'fxLayoutGap.gt-xs',
    'fxLayoutGap.gt-sm',
    'fxLayoutGap.gt-md',
    'fxLayoutGap.gt-lg',
    'stlrLayoutGap',
    'stlrLayoutGap.xs',
    'stlrLayoutGap.sm',
    'stlrLayoutGap.md',
    'stlrLayoutGap.lg',
    'stlrLayoutGap.xl',
    'stlrLayoutGap.lt-sm',
    'stlrLayoutGap.lt-md',
    'stlrLayoutGap.lt-lg',
    'stlrLayoutGap.lt-xl',
    'stlrLayoutGap.gt-xs',
    'stlrLayoutGap.gt-sm',
    'stlrLayoutGap.gt-md',
    'stlrLayoutGap.gt-lg',
];
const fillInputs = [
    'fxFill',
    'fxFill.xs',
    'fxFill.sm',
    'fxFill.md',
    'fxFill.lg',
    'fxFill.xl',
    'fxFill.lt-sm',
    'fxFill.lt-md',
    'fxFill.lt-lg',
    'fxFill.lt-xl',
    'fxFill.gt-xs',
    'fxFill.gt-sm',
    'fxFill.gt-md',
    'fxFill.gt-lg',
    'stlrFill',
    'stlrFill.xs',
    'stlrFill.sm',
    'stlrFill.md',
    'stlrFill.lg',
    'stlrFill.xl',
    'stlrFill.lt-sm',
    'stlrFill.lt-md',
    'stlrFill.lt-lg',
    'stlrFill.lt-xl',
    'stlrFill.gt-xs',
    'stlrFill.gt-sm',
    'stlrFill.gt-md',
    'stlrFill.gt-lg',
];
const hideInputs = [
    'fxHide',
    'fxHide.xs',
    'fxHide.sm',
    'fxHide.md',
    'fxHide.lg',
    'fxHide.xl',
    'fxHide.lt-sm',
    'fxHide.lt-md',
    'fxHide.lt-lg',
    'fxHide.lt-xl',
    'fxHide.gt-xs',
    'fxHide.gt-sm',
    'fxHide.gt-md',
    'fxHide.gt-lg',
    'stlrHide',
    'stlrHide.xs',
    'stlrHide.sm',
    'stlrHide.md',
    'stlrHide.lg',
    'stlrHide.xl',
    'stlrHide.lt-sm',
    'stlrHide.lt-md',
    'stlrHide.lt-lg',
    'stlrHide.lt-xl',
    'stlrHide.gt-xs',
    'stlrHide.gt-sm',
    'stlrHide.gt-md',
    'stlrHide.gt-lg',
];

const flexSelectors = `[stlrFlex], [stlrFlex.xs],
        [stlrFlex.sm], [stlrFlex.md], [stlrFlex.lg], [stlrFlex.xl],
        [stlrFlex.lt-sm], [stlrFlex.lt-md], [stlrFlex.lt-lg],
        [stlrFlex.lt-xl], [stlrFlex.gt-xs], [stlrFlex.gt-sm],
        [stlrFlex.gt-md], [stlrFlex.gt-lg],
        [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],
        [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],
        [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],
        [fxFlex.gt-md], [fxFlex.gt-lg]
    `;
const flexAlignSelectors = `[stlrFlexAlign], [stlrFlexAlign.xs],
        [stlrFlexAlign.sm], [stlrFlexAlign.md], [stlrFlexAlign.lg], [stlrFlexAlign.xl],
        [stlrFlexAlign.lt-sm], [stlrFlexAlign.lt-md], [stlrFlexAlign.lt-lg],
        [stlrFlexAlign.lt-xl], [stlrFlexAlign.gt-xs], [stlrFlexAlign.gt-sm],
        [stlrFlexAlign.gt-md], [stlrFlexAlign.gt-lg],
        [fxFlexAlign], [fxFlexAlign.xs], [fxFlexAlign.sm], [fxFlexAlign.md],
        [fxFlexAlign.lg], [fxFlexAlign.xl], [fxFlexAlign.lt-sm], [fxFlexAlign.lt-md],
        [fxFlexAlign.lt-lg], [fxFlexAlign.lt-xl], [fxFlexAlign.gt-xs], [fxFlexAlign.gt-sm],
        [fxFlexAlign.gt-md], [fxFlexAlign.gt-lg]
    `;
const flexOrderSelectors = `[stlrFlexOrder], [stlrFlexOrder.xs],
        [stlrFlexOrder.sm], [stlrFlexOrder.md], [stlrFlexOrder.lg], [stlrFlexOrder.xl],
        [stlrFlexOrder.lt-sm], [stlrFlexOrder.lt-md], [stlrFlexOrder.lt-lg],
        [stlrFlexOrder.lt-xl], [stlrFlexOrder.gt-xs], [stlrFlexOrder.gt-sm],
        [stlrFlexOrder.gt-md], [stlrFlexOrder.gt-lg],
        [fxFlexOrder], [fxFlexOrder.xs], [fxFlexOrder.sm], [fxFlexOrder.md],
        [fxFlexOrder.lg], [fxFlexOrder.xl], [fxFlexOrder.lt-sm], [fxFlexOrder.lt-md],
        [fxFlexOrder.lt-lg], [fxFlexOrder.lt-xl], [fxFlexOrder.gt-xs], [fxFlexOrder.gt-sm],
        [fxFlexOrder.gt-md], [fxFlexOrder.gt-lg]
    `;
const layoutSelectors = `[stlrLayout], [stlrLayout.xs],
        [stlrLayout.sm], [stlrLayout.md], [stlrLayout.lg], [stlrLayout.xl],
        [stlrLayout.lt-sm], [stlrLayout.lt-md], [stlrLayout.lt-lg],
        [stlrLayout.lt-xl], [stlrLayout.gt-xs], [stlrLayout.gt-sm],
        [stlrLayout.gt-md], [stlrLayout.gt-lg],
        [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],
        [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],
        [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],
        [fxLayout.gt-md], [fxLayout.gt-lg]
    `;
const layoutAlignSelectors = `[stlrLayoutAlign], [stlrLayoutAlign.xs],
        [stlrLayoutAlign.sm], [stlrLayoutAlign.md], [stlrLayoutAlign.lg], [stlrLayoutAlign.xl],
        [stlrLayoutAlign.lt-sm], [stlrLayoutAlign.lt-md], [stlrLayoutAlign.lt-lg],
        [stlrLayoutAlign.lt-xl], [stlrLayoutAlign.gt-xs], [stlrLayoutAlign.gt-sm],
        [stlrLayoutAlign.gt-md], [stlrLayoutAlign.gt-lg],
        [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],
        [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],
        [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],
        [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]
    `;
const layoutGapSelectors = `[stlrLayoutGap], [stlrLayoutGap.xs],
        [stlrLayoutGap.sm], [stlrLayoutGap.md], [stlrLayoutGap.lg], [stlrLayoutGap.xl],
        [stlrLayoutGap.lt-sm], [stlrLayoutGap.lt-md], [stlrLayoutGap.lt-lg],
        [stlrLayoutGap.lt-xl], [stlrLayoutGap.gt-xs], [stlrLayoutGap.gt-sm],
        [stlrLayoutGap.gt-md], [stlrLayoutGap.gt-lg],
        [fxLayoutGap], [fxLayoutGap.xs], [fxLayoutGap.sm], [fxLayoutGap.md],
        [fxLayoutGap.lg], [fxLayoutGap.xl], [fxLayoutGap.lt-sm], [fxLayoutGap.lt-md],
        [fxLayoutGap.lt-lg], [fxLayoutGap.lt-xl], [fxLayoutGap.gt-xs], [fxLayoutGap.gt-sm],
        [fxLayoutGap.gt-md], [fxLayoutGap.gt-lg]
    `;
const fillSelectors = `[stlrFill], [stlrFill.xs],
        [stlrFill.sm], [stlrFill.md], [stlrFill.lg], [stlrFill.xl],
        [stlrFill.lt-sm], [stlrFill.lt-md], [stlrFill.lt-lg],
        [stlrFill.lt-xl], [stlrFill.gt-xs], [stlrFill.gt-sm],
        [stlrFill.gt-md], [stlrFill.gt-lg],
        [fxFill], [fxFill.xs], [fxFill.sm], [fxFill.md],
        [fxFill.lg], [fxFill.xl], [fxFill.lt-sm], [fxFill.lt-md],
        [fxFill.lt-lg], [fxFill.lt-xl], [fxFill.gt-xs], [fxFill.gt-sm],
        [fxFill.gt-md], [fxFill.gt-lg]
    `;
const hideSelectors = `[stlrHide], [stlrHide.xs],
    [stlrHide.sm], [stlrHide.md], [stlrHide.lg], [stlrHide.xl],
    [stlrHide.lt-sm], [stlrHide.lt-md], [stlrHide.lt-lg],
    [stlrHide.lt-xl], [stlrHide.gt-xs], [stlrHide.gt-sm],
    [stlrHide.gt-md], [stlrHide.gt-lg],
    [fxHide], [fxHide.xs], [fxHide.sm], [fxHide.md],
    [fxHide.lg], [fxHide.xl], [fxHide.lt-sm], [fxHide.lt-md],
    [fxHide.lt-lg], [fxHide.lt-xl], [fxHide.gt-xs], [fxHide.gt-sm],
    [fxHide.gt-md], [fxHide.gt-lg]
`;

// Programmatic breakpoint map. MUST match _flex.scss in assets/scss
const BreakpointMap = new Map([
    ['xs', 'screen and (max-width: 599px)'],
    ['sm', 'screen and (min-width: 600px) and (max-width: 959px)'],
    ['md', 'screen and (min-width: 960px) and (max-width: 1279px)'],
    ['lg', 'screen and (min-width: 1280px) and (max-width: 1919px)'],
    ['xl', 'screen and (min-width: 1920px) and (max-width: 5000px)'],
    ['lt-sm', 'screen and (max-width: 599px)'],
    ['lt-md', 'screen and (max-width: 959px)'],
    ['lt-lg', 'screen and (max-width: 1279px)'],
    ['lt-xl', 'screen and (max-width: 1919px)'],
    ['gt-xs', 'screen and (min-width: 600px)'],
    ['gt-sm', 'screen and (min-width: 960px)'],
    ['gt-md', 'screen and (min-width: 1280px)'],
    ['gt-lg', 'screen and (min-width: 1920px)'],
]);

// It may be overkill to wrap this in a service--it's just a wrapper around the
// BreakpointObserver, which is already a service. At the time I expected to need
// to do more with it, but I don't think that's the case anymore. I'm leaving it
// in for now in case I need to do something else with it later.
class BreakpointService {
    constructor() {
        this._breakpointObserver = inject(BreakpointObserver);
    }
    observe(mediaQuery) {
        return this._breakpointObserver.observe(mediaQuery);
    }
    static { this.ɵfac = function BreakpointService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BreakpointService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BreakpointService, factory: BreakpointService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreakpointService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

class BaseFlexDirective {
    constructor() {
        this._changeDetectorRef = inject(ChangeDetectorRef);
        this._breakpointService = inject(BreakpointService);
        this._destroy$ = new Subject();
        this._elementRef = inject(ElementRef);
        this.classList = [];
    }
    ngOnInit() {
        const queries = Array.from(BreakpointMap.values());
        this._breakpointService
            .observe(queries)
            .pipe(takeUntil(this._destroy$))
            .subscribe((state) => {
            const breakpoints = new Map(Array.from(BreakpointMap.entries()).map(([key, query]) => [
                key,
                state.breakpoints[query],
            ]));
            this._buildStyle(breakpoints);
            this._changeDetectorRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    static { this.ɵfac = function BaseFlexDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BaseFlexDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: BaseFlexDirective }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFlexDirective, [{
        type: Directive
    }], null, null); })();

class StlrFlexAlignDirective extends BaseFlexDirective {
    constructor() {
        super(...arguments);
        this.directiveKey = 'flex-align';
        this.inputs = flexAlignInputs;
    }
    get class() {
        // Where the magic happens--we build the class list rather than 1 million HostBindings
        return this.classList.join(' ');
    }
    _buildStyle(breakpoints) {
        this.classList = [`stlr-${this.directiveKey}`];
        const inputsWithValue = this.inputs.filter((input) => !!this[input]);
        const hasAliasedBreakpointActive = inputsWithValue
            .filter((input) => input.includes('.'))
            .map((input) => input.split('.')[1])
            .some((alias) => breakpoints.get(alias) === true);
        for (const input of inputsWithValue) {
            const alias = input.split('.')[1]; // Alias = 'sm', 'lt-md', etc.
            const breakpoint = breakpoints.get(alias); // True if the aliased breakpoint is active based on user screen size
            const plain = !input.includes('.'); // True if there is no alias (i.e. 'fxLayout' instead of 'fxLayout.sm')
            let value = this[input]?.toString(); // row, column, etc.
            // This makes the value CSS friendly (i.e. 'fxLayout="row wrap"' becomes 'row-wrap')
            value = value?.replace(' ', '-');
            if (breakpoint && alias) {
                this.classList.push(`stlr-${this.directiveKey}--${value}-${alias}`);
            }
            else if (plain && !hasAliasedBreakpointActive) {
                this.classList.push(`stlr-${this.directiveKey}--${value}`);
            }
        }
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵStlrFlexAlignDirective_BaseFactory; return function StlrFlexAlignDirective_Factory(__ngFactoryType__) { return (ɵStlrFlexAlignDirective_BaseFactory || (ɵStlrFlexAlignDirective_BaseFactory = i0.ɵɵgetInheritedFactory(StlrFlexAlignDirective)))(__ngFactoryType__ || StlrFlexAlignDirective); }; })(); }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StlrFlexAlignDirective, selectors: [["", "stlrFlexAlign", ""], ["", "stlrFlexAlign.xs", ""], ["", "stlrFlexAlign.sm", ""], ["", "stlrFlexAlign.md", ""], ["", "stlrFlexAlign.lg", ""], ["", "stlrFlexAlign.xl", ""], ["", "stlrFlexAlign.lt-sm", ""], ["", "stlrFlexAlign.lt-md", ""], ["", "stlrFlexAlign.lt-lg", ""], ["", "stlrFlexAlign.lt-xl", ""], ["", "stlrFlexAlign.gt-xs", ""], ["", "stlrFlexAlign.gt-sm", ""], ["", "stlrFlexAlign.gt-md", ""], ["", "stlrFlexAlign.gt-lg", ""], ["", "fxFlexAlign", ""], ["", "fxFlexAlign.xs", ""], ["", "fxFlexAlign.sm", ""], ["", "fxFlexAlign.md", ""], ["", "fxFlexAlign.lg", ""], ["", "fxFlexAlign.xl", ""], ["", "fxFlexAlign.lt-sm", ""], ["", "fxFlexAlign.lt-md", ""], ["", "fxFlexAlign.lt-lg", ""], ["", "fxFlexAlign.lt-xl", ""], ["", "fxFlexAlign.gt-xs", ""], ["", "fxFlexAlign.gt-sm", ""], ["", "fxFlexAlign.gt-md", ""], ["", "fxFlexAlign.gt-lg", ""]], hostVars: 2, hostBindings: function StlrFlexAlignDirective_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
        } }, inputs: { fxFlexAlign: "fxFlexAlign", "fxFlexAlign.xs": "fxFlexAlign.xs", "fxFlexAlign.sm": "fxFlexAlign.sm", "fxFlexAlign.md": "fxFlexAlign.md", "fxFlexAlign.lg": "fxFlexAlign.lg", "fxFlexAlign.xl": "fxFlexAlign.xl", "fxFlexAlign.lt-sm": "fxFlexAlign.lt-sm", "fxFlexAlign.lt-md": "fxFlexAlign.lt-md", "fxFlexAlign.lt-lg": "fxFlexAlign.lt-lg", "fxFlexAlign.lt-xl": "fxFlexAlign.lt-xl", "fxFlexAlign.gt-xs": "fxFlexAlign.gt-xs", "fxFlexAlign.gt-sm": "fxFlexAlign.gt-sm", "fxFlexAlign.gt-md": "fxFlexAlign.gt-md", "fxFlexAlign.gt-lg": "fxFlexAlign.gt-lg", stlrFlexAlign: "stlrFlexAlign", "stlrFlexAlign.xs": "stlrFlexAlign.xs", "stlrFlexAlign.sm": "stlrFlexAlign.sm", "stlrFlexAlign.md": "stlrFlexAlign.md", "stlrFlexAlign.lg": "stlrFlexAlign.lg", "stlrFlexAlign.xl": "stlrFlexAlign.xl", "stlrFlexAlign.lt-sm": "stlrFlexAlign.lt-sm", "stlrFlexAlign.lt-md": "stlrFlexAlign.lt-md", "stlrFlexAlign.lt-lg": "stlrFlexAlign.lt-lg", "stlrFlexAlign.lt-xl": "stlrFlexAlign.lt-xl", "stlrFlexAlign.gt-xs": "stlrFlexAlign.gt-xs", "stlrFlexAlign.gt-sm": "stlrFlexAlign.gt-sm", "stlrFlexAlign.gt-md": "stlrFlexAlign.gt-md", "stlrFlexAlign.gt-lg": "stlrFlexAlign.gt-lg" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrFlexAlignDirective, [{
        type: Directive,
        args: [{
                selector: flexAlignSelectors,
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: flexAlignInputs,
            }]
    }], null, { class: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class StlrFlexOrderDirective extends BaseFlexDirective {
    constructor() {
        super(...arguments);
        this.directiveKey = 'flex-order';
        this.inputs = flexOrderInputs;
    }
    // No HostBinding to the class since this one uses inline styles
    _buildStyle(breakpoints) {
        // Get the existing styles so we don't overwrite them
        const styles = this._elementRef.nativeElement.style;
        const inputsWithValue = this.inputs.filter((input) => !!this[input]);
        const hasAliasedBreakpointActive = inputsWithValue
            .filter((input) => input.includes('.'))
            .map((input) => input.split('.')[1])
            .some((alias) => breakpoints.get(alias) === true);
        for (const input of inputsWithValue) {
            const alias = input.split('.')[1]; // Alias = 'sm', 'lt-md', etc.
            const breakpoint = breakpoints.get(alias); // True if the aliased breakpoint is active based on user screen size
            const plain = !input.includes('.'); // True if there is no alias (i.e. 'fxLayout' instead of 'fxLayout.sm')
            const value = this[input]?.toString(); // 1, 2, 3, etc.
            if ((breakpoint && alias) ||
                (plain && !hasAliasedBreakpointActive)) {
                styles.order = value;
            }
        }
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵStlrFlexOrderDirective_BaseFactory; return function StlrFlexOrderDirective_Factory(__ngFactoryType__) { return (ɵStlrFlexOrderDirective_BaseFactory || (ɵStlrFlexOrderDirective_BaseFactory = i0.ɵɵgetInheritedFactory(StlrFlexOrderDirective)))(__ngFactoryType__ || StlrFlexOrderDirective); }; })(); }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StlrFlexOrderDirective, selectors: [["", "stlrFlexOrder", ""], ["", "stlrFlexOrder.xs", ""], ["", "stlrFlexOrder.sm", ""], ["", "stlrFlexOrder.md", ""], ["", "stlrFlexOrder.lg", ""], ["", "stlrFlexOrder.xl", ""], ["", "stlrFlexOrder.lt-sm", ""], ["", "stlrFlexOrder.lt-md", ""], ["", "stlrFlexOrder.lt-lg", ""], ["", "stlrFlexOrder.lt-xl", ""], ["", "stlrFlexOrder.gt-xs", ""], ["", "stlrFlexOrder.gt-sm", ""], ["", "stlrFlexOrder.gt-md", ""], ["", "stlrFlexOrder.gt-lg", ""], ["", "fxFlexOrder", ""], ["", "fxFlexOrder.xs", ""], ["", "fxFlexOrder.sm", ""], ["", "fxFlexOrder.md", ""], ["", "fxFlexOrder.lg", ""], ["", "fxFlexOrder.xl", ""], ["", "fxFlexOrder.lt-sm", ""], ["", "fxFlexOrder.lt-md", ""], ["", "fxFlexOrder.lt-lg", ""], ["", "fxFlexOrder.lt-xl", ""], ["", "fxFlexOrder.gt-xs", ""], ["", "fxFlexOrder.gt-sm", ""], ["", "fxFlexOrder.gt-md", ""], ["", "fxFlexOrder.gt-lg", ""]], inputs: { fxFlexOrder: "fxFlexOrder", "fxFlexOrder.xs": "fxFlexOrder.xs", "fxFlexOrder.sm": "fxFlexOrder.sm", "fxFlexOrder.md": "fxFlexOrder.md", "fxFlexOrder.lg": "fxFlexOrder.lg", "fxFlexOrder.xl": "fxFlexOrder.xl", "fxFlexOrder.lt-sm": "fxFlexOrder.lt-sm", "fxFlexOrder.lt-md": "fxFlexOrder.lt-md", "fxFlexOrder.lt-lg": "fxFlexOrder.lt-lg", "fxFlexOrder.lt-xl": "fxFlexOrder.lt-xl", "fxFlexOrder.gt-xs": "fxFlexOrder.gt-xs", "fxFlexOrder.gt-sm": "fxFlexOrder.gt-sm", "fxFlexOrder.gt-md": "fxFlexOrder.gt-md", "fxFlexOrder.gt-lg": "fxFlexOrder.gt-lg", stlrFlexOrder: "stlrFlexOrder", "stlrFlexOrder.xs": "stlrFlexOrder.xs", "stlrFlexOrder.sm": "stlrFlexOrder.sm", "stlrFlexOrder.md": "stlrFlexOrder.md", "stlrFlexOrder.lg": "stlrFlexOrder.lg", "stlrFlexOrder.xl": "stlrFlexOrder.xl", "stlrFlexOrder.lt-sm": "stlrFlexOrder.lt-sm", "stlrFlexOrder.lt-md": "stlrFlexOrder.lt-md", "stlrFlexOrder.lt-lg": "stlrFlexOrder.lt-lg", "stlrFlexOrder.lt-xl": "stlrFlexOrder.lt-xl", "stlrFlexOrder.gt-xs": "stlrFlexOrder.gt-xs", "stlrFlexOrder.gt-sm": "stlrFlexOrder.gt-sm", "stlrFlexOrder.gt-md": "stlrFlexOrder.gt-md", "stlrFlexOrder.gt-lg": "stlrFlexOrder.gt-lg" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrFlexOrderDirective, [{
        type: Directive,
        args: [{
                selector: flexOrderSelectors,
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: flexOrderInputs,
            }]
    }], null, null); })();

class StlrFlexDirective extends BaseFlexDirective {
    constructor() {
        super(...arguments);
        this.directiveKey = 'flex';
        this.inputs = flexInputs;
    }
    // No HostBinding to the class since this one uses inline styles
    _buildStyle(breakpoints) {
        // Get the existing styles so we don't overwrite them
        const styles = this._elementRef.nativeElement.style;
        const inputsWithValue = this.inputs.filter((input) => !!this[input]);
        const hasAliasedBreakpointActive = inputsWithValue
            .filter((input) => input.includes('.'))
            .map((input) => input.split('.')[1])
            .some((alias) => breakpoints.get(alias) === true);
        for (const input of inputsWithValue) {
            const alias = input.split('.')[1]; // Alias = 'sm', 'lt-md', etc.
            const breakpoint = breakpoints.get(alias); // True if the aliased breakpoint is active based on user screen size
            const plain = !input.includes('.'); // True if there is no alias (i.e. 'fxLayout' instead of 'fxLayout.sm')
            const value = this[input]?.toString(); // row, column, etc.
            if ((breakpoint && alias) ||
                (plain && !hasAliasedBreakpointActive)) {
                styles.flex = value;
            }
        }
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵStlrFlexDirective_BaseFactory; return function StlrFlexDirective_Factory(__ngFactoryType__) { return (ɵStlrFlexDirective_BaseFactory || (ɵStlrFlexDirective_BaseFactory = i0.ɵɵgetInheritedFactory(StlrFlexDirective)))(__ngFactoryType__ || StlrFlexDirective); }; })(); }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StlrFlexDirective, selectors: [["", "stlrFlex", ""], ["", "stlrFlex.xs", ""], ["", "stlrFlex.sm", ""], ["", "stlrFlex.md", ""], ["", "stlrFlex.lg", ""], ["", "stlrFlex.xl", ""], ["", "stlrFlex.lt-sm", ""], ["", "stlrFlex.lt-md", ""], ["", "stlrFlex.lt-lg", ""], ["", "stlrFlex.lt-xl", ""], ["", "stlrFlex.gt-xs", ""], ["", "stlrFlex.gt-sm", ""], ["", "stlrFlex.gt-md", ""], ["", "stlrFlex.gt-lg", ""], ["", "fxFlex", ""], ["", "fxFlex.xs", ""], ["", "fxFlex.sm", ""], ["", "fxFlex.md", ""], ["", "fxFlex.lg", ""], ["", "fxFlex.xl", ""], ["", "fxFlex.lt-sm", ""], ["", "fxFlex.lt-md", ""], ["", "fxFlex.lt-lg", ""], ["", "fxFlex.lt-xl", ""], ["", "fxFlex.gt-xs", ""], ["", "fxFlex.gt-sm", ""], ["", "fxFlex.gt-md", ""], ["", "fxFlex.gt-lg", ""]], inputs: { fxFlex: "fxFlex", "fxFlex.xs": "fxFlex.xs", "fxFlex.sm": "fxFlex.sm", "fxFlex.md": "fxFlex.md", "fxFlex.lg": "fxFlex.lg", "fxFlex.xl": "fxFlex.xl", "fxFlex.lt-sm": "fxFlex.lt-sm", "fxFlex.lt-md": "fxFlex.lt-md", "fxFlex.lt-lg": "fxFlex.lt-lg", "fxFlex.lt-xl": "fxFlex.lt-xl", "fxFlex.gt-xs": "fxFlex.gt-xs", "fxFlex.gt-sm": "fxFlex.gt-sm", "fxFlex.gt-md": "fxFlex.gt-md", "fxFlex.gt-lg": "fxFlex.gt-lg", stlrFlex: "stlrFlex", "stlrFlex.xs": "stlrFlex.xs", "stlrFlex.sm": "stlrFlex.sm", "stlrFlex.md": "stlrFlex.md", "stlrFlex.lg": "stlrFlex.lg", "stlrFlex.xl": "stlrFlex.xl", "stlrFlex.lt-sm": "stlrFlex.lt-sm", "stlrFlex.lt-md": "stlrFlex.lt-md", "stlrFlex.lt-lg": "stlrFlex.lt-lg", "stlrFlex.lt-xl": "stlrFlex.lt-xl", "stlrFlex.gt-xs": "stlrFlex.gt-xs", "stlrFlex.gt-sm": "stlrFlex.gt-sm", "stlrFlex.gt-md": "stlrFlex.gt-md", "stlrFlex.gt-lg": "stlrFlex.gt-lg" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrFlexDirective, [{
        type: Directive,
        args: [{
                selector: flexSelectors,
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: flexInputs,
            }]
    }], null, null); })();

class StlrLayoutAlignDirective extends BaseFlexDirective {
    constructor() {
        super(...arguments);
        this.directiveKey = 'layout-align';
        this.inputs = layoutAlignInputs;
    }
    get class() {
        // Where the magic happens--we build the class list rather than 1 million HostBindings
        return this.classList.join(' ');
    }
    _buildStyle(breakpoints) {
        this.classList = [`stlr-${this.directiveKey}`];
        const inputsWithValue = this.inputs.filter((input) => !!this[input]);
        const hasAliasedBreakpointActive = inputsWithValue
            .filter((input) => input.includes('.'))
            .map((input) => input.split('.')[1])
            .some((alias) => breakpoints.get(alias) === true);
        for (const input of inputsWithValue) {
            const alias = input.split('.')[1]; // Alias = 'sm', 'lt-md', etc.
            const breakpoint = breakpoints.get(alias); // True if the aliased breakpoint is active based on user screen size
            const plain = !input.includes('.'); // True if there is no alias (i.e. 'fxLayout' instead of 'fxLayout.sm')
            let value = this[input]?.toString(); // row, column, etc.
            // This makes the value CSS friendly (i.e. 'fxLayout="row wrap"' becomes 'row-wrap')
            value = value?.split(' ').reverse().join('-');
            if (breakpoint && alias) {
                this.classList.push(`stlr-${this.directiveKey}--${value}-${alias}`);
            }
            else if (plain && !hasAliasedBreakpointActive) {
                this.classList.push(`stlr-${this.directiveKey}--${value}`);
            }
        }
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵStlrLayoutAlignDirective_BaseFactory; return function StlrLayoutAlignDirective_Factory(__ngFactoryType__) { return (ɵStlrLayoutAlignDirective_BaseFactory || (ɵStlrLayoutAlignDirective_BaseFactory = i0.ɵɵgetInheritedFactory(StlrLayoutAlignDirective)))(__ngFactoryType__ || StlrLayoutAlignDirective); }; })(); }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StlrLayoutAlignDirective, selectors: [["", "stlrLayoutAlign", ""], ["", "stlrLayoutAlign.xs", ""], ["", "stlrLayoutAlign.sm", ""], ["", "stlrLayoutAlign.md", ""], ["", "stlrLayoutAlign.lg", ""], ["", "stlrLayoutAlign.xl", ""], ["", "stlrLayoutAlign.lt-sm", ""], ["", "stlrLayoutAlign.lt-md", ""], ["", "stlrLayoutAlign.lt-lg", ""], ["", "stlrLayoutAlign.lt-xl", ""], ["", "stlrLayoutAlign.gt-xs", ""], ["", "stlrLayoutAlign.gt-sm", ""], ["", "stlrLayoutAlign.gt-md", ""], ["", "stlrLayoutAlign.gt-lg", ""], ["", "fxLayoutAlign", ""], ["", "fxLayoutAlign.xs", ""], ["", "fxLayoutAlign.sm", ""], ["", "fxLayoutAlign.md", ""], ["", "fxLayoutAlign.lg", ""], ["", "fxLayoutAlign.xl", ""], ["", "fxLayoutAlign.lt-sm", ""], ["", "fxLayoutAlign.lt-md", ""], ["", "fxLayoutAlign.lt-lg", ""], ["", "fxLayoutAlign.lt-xl", ""], ["", "fxLayoutAlign.gt-xs", ""], ["", "fxLayoutAlign.gt-sm", ""], ["", "fxLayoutAlign.gt-md", ""], ["", "fxLayoutAlign.gt-lg", ""]], hostVars: 2, hostBindings: function StlrLayoutAlignDirective_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
        } }, inputs: { fxLayoutAlign: "fxLayoutAlign", "fxLayoutAlign.xs": "fxLayoutAlign.xs", "fxLayoutAlign.sm": "fxLayoutAlign.sm", "fxLayoutAlign.md": "fxLayoutAlign.md", "fxLayoutAlign.lg": "fxLayoutAlign.lg", "fxLayoutAlign.xl": "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm": "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md": "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg": "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl": "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs": "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm": "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md": "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg": "fxLayoutAlign.gt-lg", stlrLayoutAlign: "stlrLayoutAlign", "stlrLayoutAlign.xs": "stlrLayoutAlign.xs", "stlrLayoutAlign.sm": "stlrLayoutAlign.sm", "stlrLayoutAlign.md": "stlrLayoutAlign.md", "stlrLayoutAlign.lg": "stlrLayoutAlign.lg", "stlrLayoutAlign.xl": "stlrLayoutAlign.xl", "stlrLayoutAlign.lt-sm": "stlrLayoutAlign.lt-sm", "stlrLayoutAlign.lt-md": "stlrLayoutAlign.lt-md", "stlrLayoutAlign.lt-lg": "stlrLayoutAlign.lt-lg", "stlrLayoutAlign.lt-xl": "stlrLayoutAlign.lt-xl", "stlrLayoutAlign.gt-xs": "stlrLayoutAlign.gt-xs", "stlrLayoutAlign.gt-sm": "stlrLayoutAlign.gt-sm", "stlrLayoutAlign.gt-md": "stlrLayoutAlign.gt-md", "stlrLayoutAlign.gt-lg": "stlrLayoutAlign.gt-lg" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrLayoutAlignDirective, [{
        type: Directive,
        args: [{
                selector: layoutAlignSelectors,
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: layoutAlignInputs,
            }]
    }], null, { class: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class StlrLayoutGapDirective extends BaseFlexDirective {
    constructor() {
        super(...arguments);
        this.directiveKey = 'layout-gap';
        this.inputs = layoutGapInputs;
    }
    // No HostBinding to the class since this one uses inline styles
    _buildStyle(breakpoints) {
        // Get the existing styles so we don't overwrite them
        const styles = this._elementRef.nativeElement.style;
        const inputsWithValue = this.inputs.filter((input) => !!this[input]);
        const hasAliasedBreakpointActive = inputsWithValue
            .filter((input) => input.includes('.'))
            .map((input) => input.split('.')[1])
            .some((alias) => breakpoints.get(alias) === true);
        for (const input of inputsWithValue) {
            const alias = input.split('.')[1]; // Alias = 'sm', 'lt-md', etc.
            const breakpoint = breakpoints.get(alias); // True if the aliased breakpoint is active based on user screen size
            const plain = !input.includes('.'); // True if there is no alias (i.e. 'fxLayout' instead of 'fxLayout.sm')
            const value = this[input]?.toString(); // row, column, etc.
            if ((breakpoint && alias) ||
                (plain && !hasAliasedBreakpointActive)) {
                styles.gap = value;
            }
        }
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵStlrLayoutGapDirective_BaseFactory; return function StlrLayoutGapDirective_Factory(__ngFactoryType__) { return (ɵStlrLayoutGapDirective_BaseFactory || (ɵStlrLayoutGapDirective_BaseFactory = i0.ɵɵgetInheritedFactory(StlrLayoutGapDirective)))(__ngFactoryType__ || StlrLayoutGapDirective); }; })(); }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StlrLayoutGapDirective, selectors: [["", "stlrLayoutGap", ""], ["", "stlrLayoutGap.xs", ""], ["", "stlrLayoutGap.sm", ""], ["", "stlrLayoutGap.md", ""], ["", "stlrLayoutGap.lg", ""], ["", "stlrLayoutGap.xl", ""], ["", "stlrLayoutGap.lt-sm", ""], ["", "stlrLayoutGap.lt-md", ""], ["", "stlrLayoutGap.lt-lg", ""], ["", "stlrLayoutGap.lt-xl", ""], ["", "stlrLayoutGap.gt-xs", ""], ["", "stlrLayoutGap.gt-sm", ""], ["", "stlrLayoutGap.gt-md", ""], ["", "stlrLayoutGap.gt-lg", ""], ["", "fxLayoutGap", ""], ["", "fxLayoutGap.xs", ""], ["", "fxLayoutGap.sm", ""], ["", "fxLayoutGap.md", ""], ["", "fxLayoutGap.lg", ""], ["", "fxLayoutGap.xl", ""], ["", "fxLayoutGap.lt-sm", ""], ["", "fxLayoutGap.lt-md", ""], ["", "fxLayoutGap.lt-lg", ""], ["", "fxLayoutGap.lt-xl", ""], ["", "fxLayoutGap.gt-xs", ""], ["", "fxLayoutGap.gt-sm", ""], ["", "fxLayoutGap.gt-md", ""], ["", "fxLayoutGap.gt-lg", ""]], inputs: { fxLayoutGap: "fxLayoutGap", "fxLayoutGap.xs": "fxLayoutGap.xs", "fxLayoutGap.sm": "fxLayoutGap.sm", "fxLayoutGap.md": "fxLayoutGap.md", "fxLayoutGap.lg": "fxLayoutGap.lg", "fxLayoutGap.xl": "fxLayoutGap.xl", "fxLayoutGap.lt-sm": "fxLayoutGap.lt-sm", "fxLayoutGap.lt-md": "fxLayoutGap.lt-md", "fxLayoutGap.lt-lg": "fxLayoutGap.lt-lg", "fxLayoutGap.lt-xl": "fxLayoutGap.lt-xl", "fxLayoutGap.gt-xs": "fxLayoutGap.gt-xs", "fxLayoutGap.gt-sm": "fxLayoutGap.gt-sm", "fxLayoutGap.gt-md": "fxLayoutGap.gt-md", "fxLayoutGap.gt-lg": "fxLayoutGap.gt-lg", stlrLayoutGap: "stlrLayoutGap", "stlrLayoutGap.xs": "stlrLayoutGap.xs", "stlrLayoutGap.sm": "stlrLayoutGap.sm", "stlrLayoutGap.md": "stlrLayoutGap.md", "stlrLayoutGap.lg": "stlrLayoutGap.lg", "stlrLayoutGap.xl": "stlrLayoutGap.xl", "stlrLayoutGap.lt-sm": "stlrLayoutGap.lt-sm", "stlrLayoutGap.lt-md": "stlrLayoutGap.lt-md", "stlrLayoutGap.lt-lg": "stlrLayoutGap.lt-lg", "stlrLayoutGap.lt-xl": "stlrLayoutGap.lt-xl", "stlrLayoutGap.gt-xs": "stlrLayoutGap.gt-xs", "stlrLayoutGap.gt-sm": "stlrLayoutGap.gt-sm", "stlrLayoutGap.gt-md": "stlrLayoutGap.gt-md", "stlrLayoutGap.gt-lg": "stlrLayoutGap.gt-lg" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrLayoutGapDirective, [{
        type: Directive,
        args: [{
                selector: layoutGapSelectors,
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: layoutGapInputs,
            }]
    }], null, null); })();

class StlrLayoutDirective extends BaseFlexDirective {
    constructor() {
        super(...arguments);
        this.directiveKey = 'layout';
        this.inputs = layoutInputs;
    }
    get class() {
        // Where the magic happens--we build the class list rather than 1 million HostBindings
        return this.classList.join(' ');
    }
    _buildStyle(breakpoints) {
        this.classList = [`stlr-${this.directiveKey}`];
        const inputsWithValue = this.inputs.filter((input) => !!this[input]);
        const hasAliasedBreakpointActive = inputsWithValue
            .filter((input) => input.includes('.'))
            .map((input) => input.split('.')[1])
            .some((alias) => breakpoints.get(alias) === true);
        for (const input of inputsWithValue) {
            const alias = input.split('.')[1]; // Alias = 'sm', 'lt-md', etc.
            const breakpoint = breakpoints.get(alias); // True if the aliased breakpoint is active based on user screen size
            const plain = !input.includes('.'); // True if there is no alias (i.e. 'fxLayout' instead of 'fxLayout.sm')
            let value = this[input]?.toString(); // row, column, etc.
            // This makes the value CSS friendly (i.e. 'fxLayout="row wrap"' becomes 'row-wrap')
            value = value?.replace(' ', '-');
            if (breakpoint && alias) {
                this.classList.push(`stlr-${this.directiveKey}--${value}-${alias}`);
            }
            else if (plain && !hasAliasedBreakpointActive) {
                this.classList.push(`stlr-${this.directiveKey}--${value}`);
            }
        }
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵStlrLayoutDirective_BaseFactory; return function StlrLayoutDirective_Factory(__ngFactoryType__) { return (ɵStlrLayoutDirective_BaseFactory || (ɵStlrLayoutDirective_BaseFactory = i0.ɵɵgetInheritedFactory(StlrLayoutDirective)))(__ngFactoryType__ || StlrLayoutDirective); }; })(); }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StlrLayoutDirective, selectors: [["", "stlrLayout", ""], ["", "stlrLayout.xs", ""], ["", "stlrLayout.sm", ""], ["", "stlrLayout.md", ""], ["", "stlrLayout.lg", ""], ["", "stlrLayout.xl", ""], ["", "stlrLayout.lt-sm", ""], ["", "stlrLayout.lt-md", ""], ["", "stlrLayout.lt-lg", ""], ["", "stlrLayout.lt-xl", ""], ["", "stlrLayout.gt-xs", ""], ["", "stlrLayout.gt-sm", ""], ["", "stlrLayout.gt-md", ""], ["", "stlrLayout.gt-lg", ""], ["", "fxLayout", ""], ["", "fxLayout.xs", ""], ["", "fxLayout.sm", ""], ["", "fxLayout.md", ""], ["", "fxLayout.lg", ""], ["", "fxLayout.xl", ""], ["", "fxLayout.lt-sm", ""], ["", "fxLayout.lt-md", ""], ["", "fxLayout.lt-lg", ""], ["", "fxLayout.lt-xl", ""], ["", "fxLayout.gt-xs", ""], ["", "fxLayout.gt-sm", ""], ["", "fxLayout.gt-md", ""], ["", "fxLayout.gt-lg", ""]], hostVars: 2, hostBindings: function StlrLayoutDirective_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
        } }, inputs: { fxLayout: "fxLayout", "fxLayout.xs": "fxLayout.xs", "fxLayout.sm": "fxLayout.sm", "fxLayout.md": "fxLayout.md", "fxLayout.lg": "fxLayout.lg", "fxLayout.xl": "fxLayout.xl", "fxLayout.lt-sm": "fxLayout.lt-sm", "fxLayout.lt-md": "fxLayout.lt-md", "fxLayout.lt-lg": "fxLayout.lt-lg", "fxLayout.lt-xl": "fxLayout.lt-xl", "fxLayout.gt-xs": "fxLayout.gt-xs", "fxLayout.gt-sm": "fxLayout.gt-sm", "fxLayout.gt-md": "fxLayout.gt-md", "fxLayout.gt-lg": "fxLayout.gt-lg", stlrLayout: "stlrLayout", "stlrLayout.xs": "stlrLayout.xs", "stlrLayout.sm": "stlrLayout.sm", "stlrLayout.md": "stlrLayout.md", "stlrLayout.lg": "stlrLayout.lg", "stlrLayout.xl": "stlrLayout.xl", "stlrLayout.lt-sm": "stlrLayout.lt-sm", "stlrLayout.lt-md": "stlrLayout.lt-md", "stlrLayout.lt-lg": "stlrLayout.lt-lg", "stlrLayout.lt-xl": "stlrLayout.lt-xl", "stlrLayout.gt-xs": "stlrLayout.gt-xs", "stlrLayout.gt-sm": "stlrLayout.gt-sm", "stlrLayout.gt-md": "stlrLayout.gt-md", "stlrLayout.gt-lg": "stlrLayout.gt-lg" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrLayoutDirective, [{
        type: Directive,
        args: [{
                selector: layoutSelectors,
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: layoutInputs,
            }]
    }], null, { class: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class StlrFillDirective extends BaseFlexDirective {
    constructor() {
        super(...arguments);
        this.directiveKey = 'fill';
        this.inputs = fillInputs;
    }
    get class() {
        // Where the magic happens--we build the class list rather than 1 million HostBindings
        return this.classList.join(' ');
    }
    _buildStyle(breakpoints) {
        this.classList = [`stlr-${this.directiveKey}`];
        const inputsWithValue = this.inputs.filter((input) => !!this[input]);
        for (const input of inputsWithValue) {
            const alias = input.split('.')[1]; // Alias = 'sm', 'lt-md', etc.
            const breakpoint = breakpoints.get(alias); // True if the aliased breakpoint is active based on user screen size
            if (breakpoint && alias) {
                this.classList.push(`stlr-${this.directiveKey}--${alias}`);
                if (this.classList.includes(`stlr-${this.directiveKey}`)) {
                    const index = this.classList.indexOf(`stlr-${this.directiveKey}`);
                    this.classList.splice(index, 1);
                }
            }
        }
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵStlrFillDirective_BaseFactory; return function StlrFillDirective_Factory(__ngFactoryType__) { return (ɵStlrFillDirective_BaseFactory || (ɵStlrFillDirective_BaseFactory = i0.ɵɵgetInheritedFactory(StlrFillDirective)))(__ngFactoryType__ || StlrFillDirective); }; })(); }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StlrFillDirective, selectors: [["", "stlrFill", ""], ["", "stlrFill.xs", ""], ["", "stlrFill.sm", ""], ["", "stlrFill.md", ""], ["", "stlrFill.lg", ""], ["", "stlrFill.xl", ""], ["", "stlrFill.lt-sm", ""], ["", "stlrFill.lt-md", ""], ["", "stlrFill.lt-lg", ""], ["", "stlrFill.lt-xl", ""], ["", "stlrFill.gt-xs", ""], ["", "stlrFill.gt-sm", ""], ["", "stlrFill.gt-md", ""], ["", "stlrFill.gt-lg", ""], ["", "fxFill", ""], ["", "fxFill.xs", ""], ["", "fxFill.sm", ""], ["", "fxFill.md", ""], ["", "fxFill.lg", ""], ["", "fxFill.xl", ""], ["", "fxFill.lt-sm", ""], ["", "fxFill.lt-md", ""], ["", "fxFill.lt-lg", ""], ["", "fxFill.lt-xl", ""], ["", "fxFill.gt-xs", ""], ["", "fxFill.gt-sm", ""], ["", "fxFill.gt-md", ""], ["", "fxFill.gt-lg", ""]], hostVars: 2, hostBindings: function StlrFillDirective_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
        } }, inputs: { fxFill: "fxFill", "fxFill.xs": "fxFill.xs", "fxFill.sm": "fxFill.sm", "fxFill.md": "fxFill.md", "fxFill.lg": "fxFill.lg", "fxFill.xl": "fxFill.xl", "fxFill.lt-sm": "fxFill.lt-sm", "fxFill.lt-md": "fxFill.lt-md", "fxFill.lt-lg": "fxFill.lt-lg", "fxFill.lt-xl": "fxFill.lt-xl", "fxFill.gt-xs": "fxFill.gt-xs", "fxFill.gt-sm": "fxFill.gt-sm", "fxFill.gt-md": "fxFill.gt-md", "fxFill.gt-lg": "fxFill.gt-lg", stlrFill: "stlrFill", "stlrFill.xs": "stlrFill.xs", "stlrFill.sm": "stlrFill.sm", "stlrFill.md": "stlrFill.md", "stlrFill.lg": "stlrFill.lg", "stlrFill.xl": "stlrFill.xl", "stlrFill.lt-sm": "stlrFill.lt-sm", "stlrFill.lt-md": "stlrFill.lt-md", "stlrFill.lt-lg": "stlrFill.lt-lg", "stlrFill.lt-xl": "stlrFill.lt-xl", "stlrFill.gt-xs": "stlrFill.gt-xs", "stlrFill.gt-sm": "stlrFill.gt-sm", "stlrFill.gt-md": "stlrFill.gt-md", "stlrFill.gt-lg": "stlrFill.gt-lg" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrFillDirective, [{
        type: Directive,
        args: [{
                selector: fillSelectors,
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: fillInputs,
            }]
    }], null, { class: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class StlrHideDirective extends BaseFlexDirective {
    constructor() {
        super(...arguments);
        this.directiveKey = 'hide';
        this.inputs = hideInputs;
    }
    get class() {
        // Where the magic happens--we build the class list rather than 1 million HostBindings
        return this.classList.join(' ');
    }
    _buildStyle(breakpoints) {
        this.classList = [`stlr-${this.directiveKey}`];
        const inputsWithValue = this.inputs.filter((input) => !!this[input]);
        for (const input of inputsWithValue) {
            const alias = input.split('.')[1]; // Alias = 'sm', 'lt-md', etc.
            const breakpoint = breakpoints.get(alias); // True if the aliased breakpoint is active based on user screen size
            if (breakpoint && alias) {
                this.classList.push(`stlr-${this.directiveKey}--${alias}`);
                if (this.classList.includes(`stlr-${this.directiveKey}`)) {
                    const index = this.classList.indexOf(`stlr-${this.directiveKey}`);
                    this.classList.splice(index, 1);
                }
            }
        }
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵStlrHideDirective_BaseFactory; return function StlrHideDirective_Factory(__ngFactoryType__) { return (ɵStlrHideDirective_BaseFactory || (ɵStlrHideDirective_BaseFactory = i0.ɵɵgetInheritedFactory(StlrHideDirective)))(__ngFactoryType__ || StlrHideDirective); }; })(); }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StlrHideDirective, selectors: [["", "stlrHide", ""], ["", "stlrHide.xs", ""], ["", "stlrHide.sm", ""], ["", "stlrHide.md", ""], ["", "stlrHide.lg", ""], ["", "stlrHide.xl", ""], ["", "stlrHide.lt-sm", ""], ["", "stlrHide.lt-md", ""], ["", "stlrHide.lt-lg", ""], ["", "stlrHide.lt-xl", ""], ["", "stlrHide.gt-xs", ""], ["", "stlrHide.gt-sm", ""], ["", "stlrHide.gt-md", ""], ["", "stlrHide.gt-lg", ""], ["", "fxHide", ""], ["", "fxHide.xs", ""], ["", "fxHide.sm", ""], ["", "fxHide.md", ""], ["", "fxHide.lg", ""], ["", "fxHide.xl", ""], ["", "fxHide.lt-sm", ""], ["", "fxHide.lt-md", ""], ["", "fxHide.lt-lg", ""], ["", "fxHide.lt-xl", ""], ["", "fxHide.gt-xs", ""], ["", "fxHide.gt-sm", ""], ["", "fxHide.gt-md", ""], ["", "fxHide.gt-lg", ""]], hostVars: 2, hostBindings: function StlrHideDirective_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
        } }, inputs: { fxHide: "fxHide", "fxHide.xs": "fxHide.xs", "fxHide.sm": "fxHide.sm", "fxHide.md": "fxHide.md", "fxHide.lg": "fxHide.lg", "fxHide.xl": "fxHide.xl", "fxHide.lt-sm": "fxHide.lt-sm", "fxHide.lt-md": "fxHide.lt-md", "fxHide.lt-lg": "fxHide.lt-lg", "fxHide.lt-xl": "fxHide.lt-xl", "fxHide.gt-xs": "fxHide.gt-xs", "fxHide.gt-sm": "fxHide.gt-sm", "fxHide.gt-md": "fxHide.gt-md", "fxHide.gt-lg": "fxHide.gt-lg", stlrHide: "stlrHide", "stlrHide.xs": "stlrHide.xs", "stlrHide.sm": "stlrHide.sm", "stlrHide.md": "stlrHide.md", "stlrHide.lg": "stlrHide.lg", "stlrHide.xl": "stlrHide.xl", "stlrHide.lt-sm": "stlrHide.lt-sm", "stlrHide.lt-md": "stlrHide.lt-md", "stlrHide.lt-lg": "stlrHide.lt-lg", "stlrHide.lt-xl": "stlrHide.lt-xl", "stlrHide.gt-xs": "stlrHide.gt-xs", "stlrHide.gt-sm": "stlrHide.gt-sm", "stlrHide.gt-md": "stlrHide.gt-md", "stlrHide.gt-lg": "stlrHide.gt-lg" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrHideDirective, [{
        type: Directive,
        args: [{
                selector: hideSelectors,
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: hideInputs,
            }]
    }], null, { class: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class StlrFlexLayoutModule {
    static { this.ɵfac = function StlrFlexLayoutModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StlrFlexLayoutModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StlrFlexLayoutModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrFlexLayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    StlrLayoutDirective,
                    StlrLayoutAlignDirective,
                    StlrFlexAlignDirective,
                    StlrFlexOrderDirective,
                    StlrFlexDirective,
                    StlrLayoutGapDirective,
                    StlrFillDirective,
                    StlrHideDirective
                ],
                exports: [
                    StlrLayoutDirective,
                    StlrLayoutAlignDirective,
                    StlrFlexAlignDirective,
                    StlrFlexOrderDirective,
                    StlrFlexDirective,
                    StlrLayoutGapDirective,
                    StlrFillDirective,
                    StlrHideDirective
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(StlrFlexLayoutModule, { imports: [CommonModule,
        StlrLayoutDirective,
        StlrLayoutAlignDirective,
        StlrFlexAlignDirective,
        StlrFlexOrderDirective,
        StlrFlexDirective,
        StlrLayoutGapDirective,
        StlrFillDirective,
        StlrHideDirective], exports: [StlrLayoutDirective,
        StlrLayoutAlignDirective,
        StlrFlexAlignDirective,
        StlrFlexOrderDirective,
        StlrFlexDirective,
        StlrLayoutGapDirective,
        StlrFillDirective,
        StlrHideDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { StlrFillDirective, StlrFlexAlignDirective, StlrFlexDirective, StlrFlexLayoutModule, StlrFlexOrderDirective, StlrHideDirective, StlrLayoutAlignDirective, StlrLayoutDirective, StlrLayoutGapDirective };

